export default [
  {
    fullName: 'Валерий Ишутин',
    jobTitle: 'Руководитель направления развития платформенных сервисов',
    description: '',
    photo: require('@/assets/speakers/webinar200x200.png')
  }
]
